import React from 'react'

export default function DiscountRulesSummary({ discount }) {
  if(!discount) return;

  if(!discount.discount_rulesets || discount.discount_rulesets.length == 0) {
    return null;
  }

  function displaySource(rule) {
    switch(rule.locations_by) {
      case 'by_state':
        return rule.state_name ? rule.state_name : "All States"
      case 'by_secondary_chain':
        return rule?.secondary_chain.name
      default:
        return ''
    }
  }


  const rows = discount.discount_rulesets.map((ruleset, index) => {
    const chainName = ruleset?.chain?.name;
    const policyType = ruleset.policy_type_display;

    if(!ruleset.rules || ruleset.rules.length === 0) {
      <tr key={`rule-${index}`} className="even:bg-gray-50 dark:even:bg-gray-800/50">
        <td colSpan={6}>
          No rules
        </td>
      </tr>
    }

    return ruleset.rules.map((rule, rIndex) => {
      return (
        <tr key={`rule-${index}-${rIndex}`} className="even:bg-gray-50 dark:even:bg-gray-800/50">
          <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-3 dark:text-white">
            {policyType}
          </td>
          <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-3 dark:text-white">
            {chainName}
          </td>
          <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-3 dark:text-white">
            { displaySource(rule)}
          </td>
          <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-3 dark:text-white">
            {rule.strategy}
          </td>
          <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-3 dark:text-white">
            {rule.cost_plus}
          </td>
          <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-3 dark:text-white">
            {rule.retail_minus}
          </td>
        </tr>
      )
    })
  })

  return (
    <table className="relative min-w-full divide-y divide-gray-300 dark:divide-white/15">
      <thead>
        <tr>
          <th
            scope="col"
            className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-3 dark:text-white"
          >
            Type
          </th>
          <th
            scope="col"
            className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-3 dark:text-white"
          >
            Chain
          </th>
          <th
            scope="col"
            className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-3 dark:text-white"
          >
            Source
          </th>
          <th
            scope="col"
            className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-3 dark:text-white"
          >
            Strategy
          </th>
          <th
            scope="col"
            className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-3 dark:text-white"
          >
            Cost Plus
          </th>
          <th
            scope="col"
            className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-3 dark:text-white"
          >
            Retail Minus
          </th>
        </tr>
      </thead>
      <tbody className="bg-white dark:bg-gray-900">
        { rows }
      </tbody>
    </table>
  )
}
